module.exports = __webpack_public_path__ + "static/media/afiche-coromoto-369-anos-791x1024.33caeac5.jpg";